var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "label-wrapper" }, [
    _c("div", { staticClass: "field__label label text-field__label" }, [
      _c(
        "label",
        { staticClass: "label__elm", attrs: { for: _vm.forName } },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm._f("capitalize")(_vm.displayLabel)) +
              "\n      "
          ),
          _vm.info
            ? [
                _c("tg-popper", {
                  attrs: { "popup-text": _vm.info },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "reference",
                        fn: function() {
                          return [
                            _c("font-awesome-icon", {
                              staticClass: "label__icon",
                              attrs: { icon: "info-circle", "fixed-witdth": "" }
                            })
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    2846234456
                  )
                })
              ]
            : _vm._e()
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }